module.exports = __webpack_public_path__ + "img/ugnc.1bb97ea3.svg";